import React, {useState, useEffect} from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

Array.prototype.except = function(val) {
    return this.filter(function(x) { return x !== val; });
};

function ShopItemDescription({title, description, additionalDescription, imagesData}) {
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const [imagesIndexes, setImagesIndexes] = useState([]);

    useEffect(() => {
        let startingArr = [...Array(imagesData.length).keys()];
        setImagesIndexes(startingArr);
    }, [mainImageIndex]);


    const handleImageClick = (imageIndex) => {
        setMainImageIndex(imageIndex)
    };

    return (
        <div className="about-area ptb--80 bg_color--1">
            <div className="about-wrapper">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-6 col-md-12">
                            <div className="thumbnail">
                                <GatsbyImage image={getImage(imagesData[mainImageIndex])} alt={title} className="img-fluid w-100" />
                            </div>

                            <div className="other-product-images-container">
                                { imagesIndexes.map(imageIndex => (
                                    <GatsbyImage
                                        image={getImage(imagesData[imageIndex])}
                                        alt={title}
                                        className={`product-gallery-image ${imageIndex === mainImageIndex && 'active'}`}
                                        onClick={() => handleImageClick(imageIndex)}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <div className="about-inner inner">
                                <div className="section-title">
                                    <h2 className="title">{title}</h2>
                                    <p className="description">{description}</p>
                                    <p className="additional-description">{additionalDescription}</p>

                                    <p className="back-button">
                                        <Link
                                            to="/obisci-rudnik/trgovina-in-spominki"
                                            className="btn-default size-sm back-to-shop-btn"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="" style={{height: "17px", marginRight: "5px"}} fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                 stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                                            </svg>
                                            <span>
                                                Nazaj na vse izdelke
                                            </span>
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShopItemDescription;
